module.exports = __webpack_public_path__ + "static/media/mobilerecipesectionbackground.7cfa55cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/mobilerecipesectionbackground.jpg
// module id = 324
// module chunks = 0